import { MockFactory } from '@tino-frontend/mocks'
import { BillListResponseV3, BillSnoozeActionStatus, BillStatus } from '@types'
import { allLineItemsMock } from '@fixtures/apis/bill/line-item/all-line-items'
import { billBaseMock } from '@fixtures/apis/bill/detail-v3/bill-base'
import { billBaseEmptyMock } from '@fixtures/apis/bill/detail-v3/bill-base-empty'
import { lineItemInstallment } from '@fixtures/apis/bill/line-item/installment'
import { lineItemBalanceMock } from '@fixtures/apis/bill/line-item/cash-in-balance'
import { lineItemDebitPurchaseMock } from '@fixtures/apis/bill/line-item/debt-purchase'
import { snoozeDetailsBaseMock } from '@fixtures/apis/bill/list-v3/snooze-details-base'

// Bill
const bill0 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-SNOOZE-0',
    status: BillStatus.Overdue,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)

const bill1 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-SNOOZE-1',
    status: BillStatus.Overdue,
    due_date: '2022-01-05T00:00:00Z',
    paid_amount: 0,
    flags: {
      ...billBaseMock.source.flags,
    },
    line_item_groups: [
      { line_items: [lineItemBalanceMock.source], is_paid: false },
      {
        line_items: [
          lineItemBalanceMock.build(
            {
              ...lineItemBalanceMock.source,
              amount_cents: 0,
              metadata: {
                ...lineItemBalanceMock.source.metadata,
                amount_cents: 0,
              },
            },
            { mergeObject: false }
          ),
        ],
        is_paid: false,
      },
    ],
  },
  { mergeArray: false }
)

const bill2 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-SNOOZE-2',
    status: BillStatus.Open,
    due_date: '2022-01-10T00:00:00Z',
    payable: true,
    flags: {
      ...billBaseMock.source.flags,
      has_debit: true,
      show_amounts_header: true,
    },
    line_item_groups: [
      {
        line_items: [
          lineItemInstallment.source,
          lineItemDebitPurchaseMock.source,
        ],
        is_paid: false,
      },
      ...allLineItemsMock.source,
    ],
    snooze_details: snoozeDetailsBaseMock.source,
  },
  { mergeArray: false }
)

const bill3 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-SNOOZE-3',
    status: BillStatus.WaitingPayment,
    due_date: '2022-01-15T00:00:00Z',
    payable: true,
    flags: {
      ...billBaseMock.source.flags,
      has_debit: true,
      show_amounts_header: true,
    },
    line_item_groups: allLineItemsMock.source,
    snooze_details: snoozeDetailsBaseMock.build(
      {
        ...snoozeDetailsBaseMock.source,
        action_status: BillSnoozeActionStatus.Preview,
      },
      { mergeArray: false }
    ),
  },
  { mergeArray: true }
)

const bill4 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-SNOOZE-4',
    status: BillStatus.Snoozed,
    due_date: '2022-01-20T00:00:00Z',
    payable: true,
    flags: {
      ...billBaseMock.source.flags,
      has_debit: true,
      show_amounts_header: true,
    },
    line_item_groups: allLineItemsMock.source,
    snooze_details: snoozeDetailsBaseMock.build(
      {
        ...snoozeDetailsBaseMock.source,
        action_status: BillSnoozeActionStatus.Review,
      },
      { mergeArray: false }
    ),
  },
  { mergeArray: true }
)

const bill5 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-SNOOZE-5',
    status: BillStatus.Snoozed,
    due_date: '2022-01-25T00:00:00Z',
    flags: {
      ...billBaseMock.source.flags,
      has_debit: true,
      show_amounts_header: true,
    },
    line_item_groups: allLineItemsMock.source,
    snooze_details: snoozeDetailsBaseMock.build(
      {
        ...snoozeDetailsBaseMock.source,
        action_status: BillSnoozeActionStatus.Preview,
      },
      { mergeArray: false }
    ),
  },
  { mergeArray: true }
)

const bill6 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-SNOOZE-6',
    status: BillStatus.Open,
    due_date: '2022-01-30T00:00:00Z',
    paid_amount: 0,
    flags: {
      ...billBaseMock.source.flags,
      has_debit: true,
      show_amounts_header: true,
    },
    line_item_groups: allLineItemsMock.source,
  },
  { mergeArray: true }
)

const bill7 = billBaseEmptyMock.build(
  {
    ...billBaseEmptyMock.source,
    due_date: '2022-02-01T00:00:00Z',
    id: 'bill-SNOOZE-7',
  },
  { mergeArray: true }
)

export const billListSnoozeMock = new MockFactory<BillListResponseV3>({
  current_bill_id: 'bill-SNOOZE-2',
  bills: [bill0, bill1, bill2, bill3, bill4, bill5, bill6, bill7],
})

export const billListSnoozeV3Mock = new MockFactory<BillListResponseV3>({
  current_bill_id: 'bill-SNOOZE-2',
  bills: [bill0, bill2],
})
